// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"367cf9e4","977":"2e1ee42a"}[chunkId] + ".chunk.js";
};